module.exports = __webpack_public_path__ + "static/media/down.2aac3b08.svg";